module.exports = __webpack_public_path__ + "static/img/nothing.1341cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nothing.png
// module id = Q95m
// module chunks = 1